module.exports = __webpack_public_path__ + "bf932fb7f70c1ae7b752de0cb4c87be5.png";